if (!customElements.get('upcoming-classes-slider')) {
  customElements.define(
    'upcoming-classes-slider',
    class UpcomingClassesSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        if (!this.querySelector('.swiper-slide')) return;
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
          this.swiper = null;
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.upcoming-classes-swiper');
        if (!swiperEl || this.swiper) return;

        const mobileSingle = this.dataset.mobileSingleCard === 'true';
        const mobileSlides = mobileSingle ? 1 : 2;

        // Mirrors Related Products exactly: every breakpoint keeps its fixed
        // per-view count no matter how few products there are. With 3
        // products on desktop, that leaves the 4th slide slot empty instead
        // of stretching the 3 cards to fill the row.
        try {
          this.swiper = new Swiper(swiperEl, {
            slidesPerView: mobileSlides,
            spaceBetween: 12,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1025: {
                slidesPerView: 4,
                spaceBetween: 12,
              },
            },
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              type: 'fraction',
            },
            navigation: {
              nextEl: this.querySelector('.upcoming-classes-next'),
              prevEl: this.querySelector('.upcoming-classes-prev'),
            },
          });
        } catch (error) {
          console.error('Error initializing Upcoming Classes Swiper:', error);
        }
      }
    },
  );
}
